import { render, staticRenderFns } from "./InviteBonus.vue?vue&type=template&id=bb56699a&"
import script from "./InviteBonus.vue?vue&type=script&lang=js&"
export * from "./InviteBonus.vue?vue&type=script&lang=js&"
import style0 from "./InviteBonus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports